import { CreditLineRequestStatus } from '@40seas/entities/credit-line';
import { EnumColor } from '@40seas/frontend/common/providers';

export const creditLineRequestStatusMapping = {
    [CreditLineRequestStatus.Pending]: 'default',
    [CreditLineRequestStatus.Declined]: 'error',
    [CreditLineRequestStatus.Blocked]: 'info',
    [CreditLineRequestStatus.InReview]: 'info',
    [CreditLineRequestStatus.Approved]: 'success',
} as { [key in CreditLineRequestStatus]: EnumColor };
